import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Modal, FormGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { cloneDeep } from 'lodash';
import UploadDocuments from '../../../../Components/UploadDocuments/UploadDocuments.js';
import * as action from '../Store/SpecTemplate.action.js';
import { customStyles } from '../../../../Components/helper';
import Loader from '../../../../Components/Utility/Loader/Loader';

function AddSupportingDocuments({ show, ducumentUploaded, handleCloseModal, specTemplateId, documentTypeList }) {
  const childRef = useRef();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    documentDetail: {},
    errorLog: [],
    showLoader: false,
  });

  const { documentDetail, errorLog, showLoader } = state;

  const forms = (formData, uploadedDoc) => {
    formData.append('fileName', `${uploadedDoc.fileName}.${uploadedDoc.fileExtn}`);
    formData.append('fileExtension', uploadedDoc.fileExtn);
    formData.append('document', uploadedDoc?.document);
    formData.append('documentTitle', documentDetail?.documentTitle);
    formData.append('documentType', documentDetail?.documentType?._id);
  };

  const handleInputSelect = (value, key) => {
    const docData = cloneDeep(documentDetail);
    docData[key] = value;
    let errorLogKey = cloneDeep(errorLog);
    if (value?._id?.trim() !== '' || value?.trim() !== '') {
      errorLogKey = errorLog.filter((item) => item !== key);
    } else {
      errorLogKey.push(key);
    }
    setState((prevState) => ({
      ...prevState,
      documentDetail: docData,
      errorLog: errorLogKey,
    }));
  };
  const isValid = () => {
    const errorLogKey = [];

    if (!Object.hasOwnProperty.call(documentDetail, 'documentTitle') || documentDetail.documentTitle.trim() === '') {
      errorLogKey.push('documentTitle');
    }
    if (!Object.hasOwnProperty.call(documentDetail, 'documentType') || documentDetail.documentType._id.trim() === '') {
      errorLogKey.push('documentType');
    }

    setState((prevState) => ({
      ...prevState,
      errorLog: errorLogKey,
    }));
    return errorLogKey.length <= 0;
  };
  const addDocument = async () => {
    if (isValid() && childRef?.current) {
      const uploadedDoc = await childRef.current.selectedDocument();

      if (uploadedDoc) {
        setState((prevState) => ({
          ...prevState,
          showLoader: true,
        }));
        const formData = new FormData();
        forms(formData, uploadedDoc);

        const res = await dispatch(action.saveSupportingDocument(specTemplateId, formData, t));
        setState((prevState) => ({
          ...prevState,
          showLoader: false,
        }));
        if (res.code === 200) {
          ducumentUploaded(true);
        }
      }
    }
  };

  const handleUpload = async () => {
    const uploadedDoc = await childRef.current.selectedDocument();

    const docData = cloneDeep(documentDetail);
    docData.documentTitle = uploadedDoc?.fileName;

    setState((prevState) => ({
      ...prevState,
      documentDetail: docData,
      errorLog: errorLog.filter((item) => item !== 'documentTitle'),
    }));
  };

  return (
    <div>
      <form className="" noValidate autoComplete="off">
        <Modal show={show} size="md" backdrop="static" aria-labelledby="contained-modal-title-vcenter" className="custom-modal support-doc-modal">
          <Modal.Header>
            <div className="d-flex justify-content-between align-items-center w-100">
              <Modal.Title id="contained-modal-title-vcenter">{t('SPEC_TEMP_LIBRARY.UPLOAD_DOCUMENT')}</Modal.Title>
              <span onClick={handleCloseModal} className="icon-close cursor-pointer" />
            </div>
          </Modal.Header>
          <Modal.Body>
            {showLoader ? (
              <Loader />
            ) : (
              <>
                <div>
                  <UploadDocuments
                    setShowGradingGroupError={() => {}}
                    handleUpload={handleUpload}
                    module="specDoc"
                    hideName
                    accept=".xls, .xlsx, .pdf, .png, .jpeg, .jpg"
                    ref={childRef}
                  />
                </div>
                <Row className="mt-2">
                  <Col md={8}>
                    <FormGroup>
                      <input
                        type="text"
                        className="form-control text-bordered"
                        placeholder={t('SPEC_TEMP_LIBRARY.COL_DOC_TITLE')}
                        value={documentDetail?.documentTitle}
                        maxLength={50}
                        onChange={(e) => handleInputSelect(e.target.value, 'documentTitle')}
                      />
                      {errorLog.includes('documentTitle') && <span className="error-message">{t('SPEC_TEMP_LIBRARY.DOC_TITLE_REQUIRED')}</span>}{' '}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Select
                        name="colourWays"
                        options={documentTypeList.filter((item) => item?.isActive)}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        value={documentDetail?.documentType}
                        styles={customStyles}
                        onChange={(e) => handleInputSelect(e, 'documentType')}
                        placeholder={t('SPEC_TEMP_LIBRARY.COL_DOC_TYPE')}
                      />
                      {errorLog.includes('documentType') && <span className="error-message">{t('SPEC_TEMP_LIBRARY.DOC_TYPE_REQUIRED')}</span>}{' '}
                    </FormGroup>
                  </Col>
                </Row>
                <div className="modal-buttons mt-4 d-flex justify-content-between">
                  <button className="btn btn-default" type="button" onClick={() => handleCloseModal()}>
                    {t('SPEC_TEMP_LIBRARY.BACK')}
                  </button>
                  <button className="btn btn-default" disabled={showLoader} type="button" onClick={addDocument}>
                    {t('SPEC_TEMP_LIBRARY.ADD')}
                  </button>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      </form>
    </div>
  );
}

export default AddSupportingDocuments;
